<template>
  <right-panel title="Фильтр" :open="isOpen" @close="closeFilter">
    <a-form @submit.prevent method="get">
      <template v-if="filterTypes">
        <right-panel-title>Тип проекта</right-panel-title>
        <div>
          <a-form-item
            v-for="filterType in filterTypes"
            :key="`filter-type-` + filterType.value"
            class="checkbox-item"
          >
            <a-checkbox v-model:checked="filterType.checked">
              {{ filterType.label }}
            </a-checkbox>
          </a-form-item>
        </div>
        <hr class="mt-40 mb-40" />
      </template>
      <template v-if="filterShowcaseStatuses">
        <right-panel-title>Статус на витрине</right-panel-title>
        <div>
          <a-form-item
            v-for="filterStatus in filterShowcaseStatuses"
            :key="`filter-status-` + filterStatus.value"
            class="checkbox-item"
          >
            <a-checkbox v-model:checked="filterStatus.checked">
              {{ filterStatus.label }}
            </a-checkbox>
          </a-form-item>
        </div>
        <hr class="mt-40 mb-40" />
      </template>
      <template v-if="filterProjectStatuses.length > 0">
        <right-panel-title>Статус проекта</right-panel-title>
        <div>
          <a-form-item
            v-for="filterProjectStatus in filterProjectStatuses"
            :key="`filter-project-status-` + filterProjectStatus.value"
            class="checkbox-item"
          >
            <a-checkbox v-model:checked="filterProjectStatus.checked">
              {{ filterProjectStatus.label }}
            </a-checkbox>
          </a-form-item>
        </div>
        <hr class="mt-40 mb-40" />
      </template>
      <template v-if="filterTags">
        <right-panel-title>Ключевые слова</right-panel-title>
        <a-form-item>
          <input-tags
            placeholder="Введите ключевые слова"
            :tags="filterTags"
            @update="updateFilterTags"
          />
        </a-form-item>
      </template>
      <right-panel-buttons>
        <button-default @click="resetFilter"> Очистить </button-default>
        <button-primary @click="applyFilter"> Применить </button-primary>
      </right-panel-buttons>
    </a-form>
  </right-panel>
</template>

<script setup>
  import RightPanel from '@/views/portal/components/panels/RightPanel.vue';
  import RightPanelTitle from '@/views/portal/components/panels/RightPanelTitle.vue';
  import ButtonPrimary from '@/views/portal/components/UI/ButtonPrimary.vue';
  import ButtonDefault from '@/views/portal/components/UI/ButtonDefault.vue';
  import RightPanelButtons from '@/views/portal/components/panels/RightPanelButtons.vue';
  import InputTags from '@/views/portal/components/UI/InputTags.vue';

  const props = defineProps({
    isOpen: Boolean,
    filterTypes: Array,
    filterShowcaseStatuses: Array,
    filterProjectStatuses: {
      type: Array,
      default: () => [],
    },
    filterTags: Array,
  });

  const emit = defineEmits([
    'close',
    'update:filter',
    'resetFilter',
    'applyFilter',
  ]);

  const updateFilterTags = (newTags) =>
    emit('update:filter', { tags: newTags });
  const applyFilter = () =>
    emit('update:filter', {
      types: props.filterTypes,
      statuses: props.filterShowcaseStatuses,
      projectStatuses: props.filterProjectStatuses,
      tags: props.filterTags,
    });
  const closeFilter = () => emit('close');
  const resetFilter = () => emit('resetFilter');
</script>

<style scoped lang="scss">
  .checkbox-item {
    margin-bottom: 0;
  }
</style>
